import React, { useState, useEffect } from "react";
import "./CaseSummary.css";
import api from "../../services/baseUrl";
import PnmbLogo from "../../assets/images/pnmb-logo.png";
import PdfDownload from "../../assets/icons/pdf-download.png";
import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

export default function CaseSummary() {
  const location = useLocation();
  const documentId = location.state?.documentId;
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (documentId) {
      const fetchData = async () => {
        try {
          const response = await api.post("/law-library/default", {
            documentId,
          });
          setData(response.data.results);
        } catch (err) {
          setError(err);
          console.error(error);
        }
      };
      fetchData();
    }
  }, [documentId, data, error]);

  return (
    <div className="summary-container">
      <div className="summary-header">
        <div className="summary-logo">
          <img src={PnmbLogo} alt="" width="15%" />
          <p>Percetakan Nasional Case Report</p>
          <p>[2024]</p>
        </div>
        <div className="summary-pdf">
          <img src={PdfDownload} alt="" width="70%" />
          <p>Download Here</p>
        </div>
      </div>
      <Divider />
      <div className="summary-title">
        <p>IN THE HIGH COURT OF MALAYA AT TAIPING</p>
        <p>AB-22NCVC-3-01/2019</p>
        <p>
          ASYNN PALM OIL SDN BHD & ANOR V. CHOW KEE PALM OIL MILL HOLDING SDN
          BHD
        </p>
      </div>
      <div className="summary-content">
        <p>Heard before:</p>
        <p>Muniandy Kannyappan J</p>
      </div>
      <div className="summary-content">
        <p>Dated:</p>
        <p>05 November 2024</p>
      </div>
      <div className="summary-content">
        <p>Plaintiff / Appellant / Applicant / Prosecution:</p>
        <p>Synn Palm Oil Sdn Bhd & Anor</p>
      </div>
      <div className="summary-content">
        <p>Defendant / Respondent / Accussed / Prosecution:</p>
        <p>Chow Kee Palm Oil Mill Holding Sdn Bhd</p>
      </div>
      <div className="summary-content">
        <p>Keywords:</p>

        <p>Separate Legal Entity</p>
        <p>Separate Legal Entity</p>
      </div>
      <div className="summary-content">
        <p>Summary</p>
        <p>
          In this case, Synn Palm Oil Sdn Bhd (P1) and Ng Chong Geng & Sons Sdn
          Bhd (P2) leased a palm oil mill and effluent plant to Chow Kee Palm
          Oil Mill Holding Sdn Bhd (the defendant) under two separate
          agreements, LA1 and LA2. The defendant failed to meet various
          obligations, including providing security deposits through bank
          guarantees, paying stamp duties, and covering rent and utility bills
          after an initial payment. Post-dated cheques submitted by the
          defendant as a substitute for bank guarantees were dishonored when
          deposited by the plaintiffs. Although the plaintiffs attempted
        </p>
      </div>
      <div className="summary-content">
        <p>Cases Referred to:</p>

        <p>
          Boustead Trading (1985) Sdn Bhd v Arab Malaysian Merchant Bank Berhad
          (1995) 3 MLJ 331
        </p>
        <p>
          S & F Jewellery Trading Sdn Bhd & Ors v Fui Lian Kwong-Hing Sdn Bhd
          (2015) 8 CLJ 16
        </p>
      </div>
      <div className="summary-content">
        <p>Legislation Referred to:</p>

        <p>Evidence Act 1950</p>
        <p>Civil Law Act 1956</p>
      </div>
      <div className="summary-content">
        <p>Grounds of Judgement:</p>
        <p>Please download the PDF file for the full Grounds of Judgement.</p>
      </div>
    </div>
  );
}
